import React, { useEffect, useState } from 'react';
import api from '../api/axiosConfig';
import './SettingsPage.css';

const EMPTY = { group_name: '', contact_email: '', contact_phone: '', welcome_message: '' };

export default function SettingsPage() {
  const [form, setForm] = useState(EMPTY);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [status, setStatus] = useState(null);

  useEffect(() => {
    api.get('settings/')
      .then((r) => setForm({
        group_name: r.data.group_name || '',
        contact_email: r.data.contact_email || '',
        contact_phone: r.data.contact_phone || '',
        welcome_message: r.data.welcome_message || '',
      }))
      .catch(() => setStatus({ type: 'error', text: 'No se pudieron cargar los ajustes.' }))
      .finally(() => setLoading(false));
  }, []);

  const handleChange = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setStatus(null);
    try {
      await api.put('settings/', form);
      setStatus({ type: 'success', text: 'Ajustes guardados.' });
    } catch (err) {
      setStatus({ type: 'error', text: 'No se pudieron guardar los ajustes.' });
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="settings-loading">Cargando…</div>;

  return (
    <div className="settings-root">
      <h1 className="settings-title">⚙️ Ajustes</h1>

      <form className="settings-card" onSubmit={handleSubmit}>
        <label className="settings-label">Nombre del grupo</label>
        <input className="settings-input" value={form.group_name} onChange={handleChange('group_name')} required />

        <label className="settings-label">Correo de contacto</label>
        <input className="settings-input" type="email" value={form.contact_email} onChange={handleChange('contact_email')} />

        <label className="settings-label">Teléfono de contacto</label>
        <input className="settings-input" value={form.contact_phone} onChange={handleChange('contact_phone')} />

        <label className="settings-label">Mensaje de bienvenida</label>
        <textarea
          className="settings-textarea"
          rows={4}
          value={form.welcome_message}
          onChange={handleChange('welcome_message')}
          placeholder="Se muestra a todos en la página de Inicio"
        />

        {status && <div className={`settings-status settings-status-${status.type}`}>{status.text}</div>}

        <button className="settings-save-btn" type="submit" disabled={saving}>
          {saving ? 'Guardando…' : 'Guardar cambios'}
        </button>
      </form>
    </div>
  );
}
